export enum GA4Event {
    // GA Events
    SELECT_CONTENT = "select_content",
    LOGIN = "login",
    PURCHASE = "purchase",
    SHARE = "share",
    SIGN_UP = "sign_up",
    TUTORIAL_BEGIN = "tutorial_begin",
    TUTORIAL_COMPLETE = "tutorial_complete", // set param if exited or finished all the way through, or if triggered from dropdown menu
    START_ONBOARDING = "start_onboarding",
    COMPLETED_ONBOARDING_VIDEO = "completed_onboarding_video",

    // CUSTOM LifeAt Events
    // Page View Events
    HIT_LANDING_PAGE = "hit_landing_page",
    HIT_EXTENSION_NEW_TAB_PAGE_VIEW = "hit_extension_new_tab_page_view",

    // Error Boundary/Page Events
    GLOBAL_ERROR_FALLBACK = "global_error_fallback",

    // Generic
    COPY_SHAREABLE_LINK = "copy_shareable_link", // e.g. set param for type of link (e.g. referral or space link)
    ACKNOWLEDGE_NOTIFICATION = "acknowledge_notification",

    // User Specific
    START_USER_AUTH_FLOW = "start_user_auth_flow",
    CREATE_ACCOUNT = "create_account",
    ACCOUNT_SIGN_IN = "account_sign_in",
    ACCOUNT_SIGN_IN_ERROR = "account_sign_in_error",
    ACCOUNT_SIGN_UP = "account_sign_up",
    SIGNIN_CLICK = "signin_click",
    USER_COPY_REFERRAL_LINK = "user_copy_referral_link",

    // Subscription Events
    UPGRADE_BUTTON_CLICK = "upgrade_button_click",
    // NOTE: this event is used in event tracking for paid ads in Google Tag Manager
    STRIPE_CHECKOUT_BUTTON_CLICK = "stripe_checkout_button_click",
    // NOTE: this event is used in event tracking for paid ads in Google Tag Manager
    NEW_USER_ONBOARDING_STRIPE_CHECKOUT_BUTTON_CLICK = "new_user_onboarding_stripe_checkout_button_click",

    // Appearance Settings
    ENABLE_LIGHT_MODE = "enable_light_mode",
    ENABLE_DARK_MODE = "enable_dark_mode",
    ENABLE_FOCUS_MODE = "enable_focus_mode",
    DISABLE_FOCUS_MODE = "disable_focus_mode",

    // Spaces
    // NOTE: all space specific events should be logged using GA4Service#logSpaceEvent
    SPACE_EVENT = "space_event",
    SHUFFLE_SPACE = "shuffle_space",
    SWITCH_CATEGORY = "switch_category",
    SAVE_SPACE = "save_space",
    SELECT_SAVED_SPACE = "select_saved_space",
    CREATOR_INTERACT = "creator_interact", // set param for type of interaction (profile click, social links click, etc)
    COPY_SPACE_LINK = "copy_space_link",
    VISIT_EXPLORE_SPACES_PAGE = "navigate_explore_spaces_page",
    CHANGE_SPACE_VOLUME = "change_space_volume",

    // Widgets
    // Generic
    // NOTE: all widget specific (e.g. timer, music) events should be logged using GA4Service#logWidgetEvent
    WIDGET_INTERACT = "widget_interact",
    TOGGLE_WIDGET = "toggle_widget", // param to set widget name, open or close, and if account required
    RESET_WIDGETS = "reset_widgets",

    // Timer Widget
    TIMER_START = "timer_start", // param to set type of timer
    TIMER_END = "timer_end", // param to set type of timer

    // Music Widget
    USE_CUSTOM_SPOTIFY_CONTENT = "use_custom_spotify_content",
    // TODO: add events for enhanced spotify playlist (save playlists, etc.)

    // Soundboard Widget
    PLAY_SOUNDBOARD_SOUND = "play_soundboard_sound",

    // User Metrics
    DAILY_STREAK_INTERACT = "daily_streak_interact", // if user clicks or hovers on streak button

    // Rooms
    HOST_START_ROOM_CALL = "host_start_room_call",
    GUEST_JOIN_ROOM_CALL = "guest_join_room_call",
    SEND_ROOM_CHAT_MESSAGE = "send_room_chat_message",
}

export const GA4EventProperties = {
    // User
    account_signin_result: {
        key: "account_signin_result",
        success: "success",
        failure: "failure",
    },
    is_new_user: "is_new_user", // boolean
    referral_code: "referral_code",
    num_referrals: "num_referrals",

    // Subscriptions
    subscription_type: {
        key: "subscription_type",
        monthly: "monthly",
        yearly: "yearly",
    },
    upgrade_button_content: {
        key: "upgrade_button_content",
        authenticate: "authenticate",
        upgrade: "upgrade",
    },

    // ACKNOWLEDGE_NOTIFICATION
    notification_type: {
        key: "notification_type",
        system_notification: "system_notification",
        cookie_notification: "cookie_notification",
    },

    // WIDGET
    widget_name: "widget_name",
    toggle_widget: {
        key: "toggle_widget",
        open: "open",
        closed: "closed",
    },

    // Timer Widget
    timer_type: {
        key: "timer_type", // value set in Pomodoro.tsx
    },

    // Soundboard Widget
    soundboard_sound: {
        key: "soundboard_sound", // value is sound name (not ID) set in SoundboardWidget.tsx
    },

    // Spaces
    space_info_keys: {
        id: "space_id",
        name: "space_name",
        category: "space_category",
    },
    space_creator_name: {
        key: "space_creator_name",
    },
    space_creator_social_keys: {
        basic_creator_link: "basic_creator_link",
        instagram_key: "instagram_creator_link",
        tiktok_key: "tiktok_creator_link",
        youtube_key: "youtube_creator_link",
        custom_link_key: "custom_creator_link",
    },

    // Tutorial (default GA4 event)
    tutorial_name: "tutorial_name",
    tutorial_step: "tutorial_step",

    // Rooms
    rooms_info_id: "room_id",
    rooms_info_name: "room_name",
    rooms_call_num_participants: "video_call_num_participants",
    rooms_guest_is_new_user: "guest_is_new_user",
};

export default GA4Event;
